import { skipToken, useQueryClient, } from '@tanstack/react-query';
import { useGetApiTimesheetsByUuid, } from '../../generated/sitComponents';
import { CACHE_TIMES } from '../query';
import { getTimesheetFromTimesheetsQueryData } from '../timesheets/query';
export function useGetTimesheet(timesheetId, options) {
    const queryClient = useQueryClient();
    return useGetApiTimesheetsByUuid(timesheetId
        ? {
            pathParams: {
                id: timesheetId,
            },
        }
        : skipToken, {
        // @ts-expect-error -- We want to support overriding these `staleTime` and `gcTime` values.
        // Moving the `...options` below `staleTime` and `gcTime` causes a TS error due to a mismatch in the
        // GetTimesheetResponse/TimesheetWithEntries typing.
        staleTime: CACHE_TIMES.FIVE_SECONDS,
        gcTime: CACHE_TIMES.TWO_MINUTES,
        ...options,
        // Note, `entries` is not included in the initial data because it is not needed for the initial render.
        // This was a @ts-expect-error because react-query v5 + OpenAPI does not support `initialData` yet: https://github.com/fabien0102/openapi-codegen/issues/184
        // But now, we have to ts-expect-error staleTime due to the mismatch in `TimesheetEntry[] | undefined` and `TimesheetEntry[]` due to the type of the entries in GetTimesheetResponse
        initialData: () => timesheetId
            ? getTimesheetFromTimesheetsQueryData(queryClient, timesheetId)
            : undefined,
    });
}
//# sourceMappingURL=use-get-timesheet.js.map